import { ApiReportSectionFieldsFieldTypeChoices } from "@api/graphql/types-and-hooks";
import { useReviewFields } from "@components/QaReview/hooks/useReviewFields";

export const useReviewFieldType = (fieldId: string | undefined): ApiReportSectionFieldsFieldTypeChoices | undefined => {
  const fieldsById = useReviewFields();
  return fieldId ? fieldsById[fieldId]?.realField.fieldType : undefined;
};
